import React from 'react'
import i18n from '~/i18n'

import Callout from '~/Common-Objects/Callout'
import ButtonNew from '~/Common-Objects/UI/Button'
import Icon from '~/Common-Objects/UI/Icon'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'

import PosterSmall from '~/assets/images/setup/video-poster-small.png'

const KnowledgeBaseCallout = ({ onPosterClick, onClose }) => {
    return (
        <Callout.Wrapper onClose={onClose}>
            <Callout.Splash>
                <img
                    src={PosterSmall}
                    alt='Video Demonstration of Transpond'
                    onClick={onPosterClick}
                    data-ph='knowledgebase-open-video-modal'
                />
            </Callout.Splash>
            <Callout.Content>
                <SquareChip className='square-chip-purple'>
                    {i18n.t('setup:callout.knowledgebase.tag')}
                </SquareChip>
                <div>
                    <h4>{i18n.t('setup:callout.knowledgebase.title')}</h4>
                    <p>{i18n.t('setup:callout.knowledgebase.body')}</p>
                </div>
                <ButtonNew
                    variant='secondary'
                    size='s'
                    iconLeft={<Icon name='lifering' />}
                    href='https://transpond.io/support'
                    target='_blank'
                    postHogTag='knowledgebase-visit-knowledge-base'
                >
                    {i18n.t('setup:callout.knowledgebase.button-text')}
                </ButtonNew>
            </Callout.Content>
        </Callout.Wrapper>
    )
}

export default KnowledgeBaseCallout
